import React, { memo } from 'react'

import { Icon, Text } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import DesktopOnlyTooltip from 'Pods/Shared/DesktopOnlyTooltip/DesktopOnlyTooltip'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { ACTION } from 'Pods/ThreeDStudio/Store/constants'

function ActionPreview() {
  const t = useTranslation()
  const inputImageUrl = useThreeDStudioStore(state => state.modelSettings.inputImageUrl)
  const prompt = useThreeDStudioStore(state => state.modelSettings.prompt)
  const generationAction = useThreeDStudioStore(state => state.schema.generationAction)
  const isImageTo3D = generationAction === ACTION.IMAGE_TO_3D
  const isTextTo3D = generationAction === ACTION.TEXT_TO_3D

  if ((isImageTo3D && !inputImageUrl) || (isTextTo3D && !prompt)) {
    return null
  }

  return (
    <div className="collapsed-model-settings__row">
      <span className="collapsed-model-settings__title">{t('leftSide.actionPreview.title')}</span>
      {isImageTo3D && (
        <img
          src={inputImageUrl}
          alt="Uploaded preview"
          className="collapsed-model-settings__image-preview"
          decoding="async"
        />
      )}
      {isTextTo3D && (
        <DesktopOnlyTooltip content={prompt} id="text-to-3d-tooltip" place="right" >
          <span className="collapsed-model-settings__text-icon">
            <Icon svgComponent={Text} color="dark" notSpaced />
          </span>
        </DesktopOnlyTooltip>
      )}
    </div>
  )
}

export default memo(ActionPreview)
